import { FC } from "react";

import { ResponsiveSvgImage } from "../../ResponsiveSvgImage/ResponsiveSvgImage";
import { ChartLabelText, ResponsiveImageContentBlockData } from "../ContentBuilder.type";

interface ResponsiveImageBlockProps {
	id?: string;
	data: ResponsiveImageContentBlockData;
	chartLabel?: ChartLabelText;
}

const ResponsiveImageBlock: FC<ResponsiveImageBlockProps> = ({ id, data, chartLabel }) => {
	const { desktopImageUrl, mobileImageUrl, imageAlt, breakpoint, title, subtitle, containerClassName, desktopClassName, mobileClassName } = data;
	return (
		<ResponsiveSvgImage
			id={id}
			desktopSrc={desktopImageUrl}
			mobileSrc={mobileImageUrl}
			alt={imageAlt}
			breakpoint={breakpoint}
			title={title}
			subtitle={subtitle}
			chartLabel={chartLabel}
			containerClassName={containerClassName}
			desktopClassName={desktopClassName}
			mobileClassName={mobileClassName}
		/>
	);
};

export { ResponsiveImageBlock };
